import React, { useContext, useState } from "react";
import {
  Dialog,
  DialogType,
  DialogFooter,
} from "@fluentui/react/lib/Dialog";
import { Button, DatePicker, notification, Radio, Space } from "antd";
import NaocDailyProductionStore from "../store/naocdailyproductionstore";
import { observer } from "mobx-react-lite";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import moment from "moment";
import { ProgressIndicator } from "@fluentui/react";
import { getPickerDate } from "../../../Utility/modules/datePicker";
const { RangePicker } = DatePicker;
const modalPropsStyles = { main: { maxWidth: 600 } };
const _ = require("underscore");

const dialogContentProps = {
  type: DialogType.normal,
  title: "Production Date Query",
  subText:
    "View NAOC production data for specific production date or date ranges",
};
export const SQuery = observer(() => {
  const [queryType, setQueryType] = useState("specific");
  const [queryDate, setQueryDate] = useState({ startDate: "", endDate: "" });
  const [loading, setLoading] = useState(false);
  const naocDailyProductionStore = useContext(NaocDailyProductionStore);
  return (
    <Dialog
      hidden={!naocDailyProductionStore.showSQeryDialog}
      onDismiss={() => {
        naocDailyProductionStore.showSQeryDialog = false;
      }}
      dialogContentProps={dialogContentProps}
      modalProps={modalPropsStyles}
      minWidth={500}
    >
      <Form layout="vertical">
        <FormItem label="Query By">
          <Radio.Group
            buttonStyle="solid"
            value={queryType}
            onChange={({ target }) => {
              setQueryType(target.value);
            }}
          >
            <Radio.Button value="specific">Specific Date</Radio.Button>
            <Radio.Button value="range">Date Range</Radio.Button>
            <Radio.Button value="inception">
              Production From Inception
            </Radio.Button>
          </Radio.Group>
        </FormItem>
        {queryType === "specific" ? (
          <FormItem label="Choose production date">
            <DatePicker
              style={{ width: "213px" }}
              onChange={(date, dateString) => {
                if (date) {
                  setQueryDate({ ...queryDate, startDate: getPickerDate(date) });
                }
              }}
            />
          </FormItem>
        ) : queryType === "range" ? (
          <FormItem label="Choose production date range">
            <RangePicker
              style={{ width: "300px" }}
              onChange={(date, dateString) => {
                if (date) {
                  const [start, end] = date;
                  setQueryDate({
                    startDate: getPickerDate(start),
                    endDate: getPickerDate(end),
                  });
                }
              }}
            />
          </FormItem>
        ) : null}
      </Form>

      <DialogFooter>
        <Space>
          {naocDailyProductionStore.isLoading && (
            <ProgressIndicator
              description="retrieving production data..."
              styles={{ root: { width: "200px", textAlign: "left" } }}
            />
          )}
          <Button
            type="link"
            onClick={() => {
              naocDailyProductionStore.showSQeryDialog = false;
            }}
          >
            Close
          </Button>
          <Button
            loading={loading}
            type="primary"
            onClick={async () => {
              setLoading(true);
              try {
                let queryCriteria = {};
                naocDailyProductionStore.resultFromQuery = true;
                if (queryType === "specific") {
                  if (!_.isDate(queryDate.startDate)) {
                    notification.info({
                      message: "SPARS Feedback",
                      description: "select valid production date",
                    });
                    return;
                  }
                  queryCriteria = {
                    startDate: moment(queryDate.startDate).format(
                      "YYYY-MM-DDT00:00:00.000Z"
                    ),
                    endDate: moment(queryDate.startDate).format(
                      "YYYY-MM-DDT00:00:00.000Z"
                    ),
                    fromInception: false,
                    specificDate: true,
                  };

                  naocDailyProductionStore.gridHeaderText = `${
                    naocDailyProductionStore.productionview === "gross"
                      ? "NAOC JV(Gross)"
                      : "OANDO Share"
                  } PRODUCTION for ${moment(queryCriteria.startDate).format(
                    "ddd DD-MMM-YYYY"
                  )} `;
                } else if (queryType === "range") {
                  if (
                    !_.isDate(queryDate.startDate) ||
                    !_.isDate(queryDate.endDate)
                  ) {
                    notification.info({
                      message: "SPARS Feedback",
                      description: "select valid production date",
                    });
                    return;
                  }
                  queryCriteria = {
                    startDate: moment(queryDate.startDate).format(
                      "YYYY-MM-DDT00:00:00.000Z"
                    ),
                    endDate: moment(queryDate.endDate).format(
                      "YYYY-MM-DDT00:00:00.000Z"
                    ),
                    fromInception: false,
                    specificDate: false,
                  };

                  naocDailyProductionStore.gridHeaderText = `${
                    naocDailyProductionStore.productionview === "gross"
                      ? "NAOC JV(Gross)"
                      : "OANDO Share"
                  } PRODUCTION from ${moment(queryCriteria.startDate).format(
                    "ddd DD-MMM-YYYY"
                  )} to ${moment(queryCriteria.endDate).format(
                    "ddd DD-MMM-YYYY"
                  )}`;
                } else if (queryType === "inception") {
                  queryCriteria = {
                    startDate: moment(new Date())
                      .startOf("month")
                      .format("YYYY-MM-DDT00:00:00.000Z"),
                    endDate: moment(new Date())
                      .startOf("month")
                      .format("YYYY-MM-DDT00:00:00.000Z"),
                    fromInception: true,
                    specificDate: false,
                  };

                  naocDailyProductionStore.gridHeaderText = `${
                    naocDailyProductionStore.productionview === "gross"
                      ? "NAOC JV(Gross)"
                      : "OANDO Share"
                  }  PRODUCTION from Inception`;
                }

                naocDailyProductionStore.queryCriteria = queryCriteria;

                await naocDailyProductionStore.loadProductions();
                naocDailyProductionStore.showSQeryDialog = false;
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: error.message,
                });
              } finally {
                setLoading(false);
              }
            }}
          >
            Query
          </Button>
        </Space>
      </DialogFooter>
    </Dialog>
  );
});

